import { render } from "./RightsIssueBanner.vue?vue&type=template&id=d40de892"
import script from "./RightsIssueBanner.vue?vue&type=script&lang=js"
export * from "./RightsIssueBanner.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__